import React from 'react';
import { Container, Space } from './style';
import Item from '../Item';
import { sidebarItems } from '../helper';

export const SidebarBody = () => {
  return (
    <Container>
      <div>
        <Space />
        {sidebarItems.map(({ title, icon, path, children }, index) => (
          <Item
            key={`${index + 1}`}
            title={title}
            icon={icon}
            path={path}
            elements={children}
          />
        ))}
      </div>
    </Container>
  );
};

export default React.memo(SidebarBody);
